import React, { memo, useState } from 'react';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import { useLanguage } from '../../hooks';
import { useProjectConfig } from '../../hooks/useProjectConfig';
import { ConfirmActionDialog } from '../uiComponents';
import colors from './colors';

const SectionComponent = memo((props: any) => {
  const {
    index,
    section,
    onNameInSectionChange,
    deleteSectionHandler,
    deleteSecionAndQuestionsHandler,
    duplicateSectionHandler,
    isHovered,
    sectionCount,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openedAlert, setOpenedAlert] = useState(false);
  const [deleteOption, setDeleteOption] = useState('');
  const { blockFormBuilder } = useProjectConfig();
  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const deleteHandler = () => {
    setOpenedAlert(false);
    if (deleteOption === 'section') deleteSectionHandler(section.id);
    if (deleteOption === 'section & questions') deleteSecionAndQuestionsHandler(section.id);
  };

  const lang = useLanguage();

  return (
    <div>
      <Card
        elevation={3}
        style={{
          padding: '0 10px 0',
          borderStyle: 'solid',
          borderWidth: 1,
          borderColor: isHovered ? colors.primary : colors.trans,
        }}
      >
        <CardContent
          style={{
            padding: '16px 16px 8px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <TextField
            value={section.name}
            variant={'outlined'}
            size={'small'}
            margin={'dense'}
            fullWidth
            required
            disabled={blockFormBuilder}
            error={section.name ? false : true}
            label={lang.form_builder.sectionNameTag}
            style={{ backgroundColor: 'white' }}
            onChange={(e) => onNameInSectionChange(section.id, e.target.value)}
            onBlur={() => {
              if (section.name === '')
                onNameInSectionChange(section.id, lang.form_builder.sectionName);
            }}
            InputProps={{
              style: {
                fontSize: 12,
              },
            }}
            InputLabelProps={{
              style: {
                fontSize: 14,
              },
            }}
            inputProps={{
              maxLength: 255,
            }}
          />
          {!blockFormBuilder && (
            <MoreVertIcon
              onClick={(e: any) => handleClickMenu(e)}
              style={{ cursor: 'pointer' }}
            />
          )}
          <Menu
            id='simple-menu'
            anchorEl={anchorEl}
            keepMounted
            open={!!anchorEl}
            onClose={handleCloseMenu}
          >
            <MenuItem
              disabled={sectionCount.current === 0}
              style={{ fontSize: 12 }}
              onClick={() => {
                setAnchorEl(null);
                duplicateSectionHandler(section.id);
              }}
            >
              {lang.form_builder.duplicateSection}
            </MenuItem>
            <MenuItem
              disabled={index === 0}
              style={{ fontSize: 12 }}
              onClick={() => {
                setAnchorEl(null);
                setOpenedAlert(true);
                setDeleteOption('section');
              }}
            >
              {lang.form_builder.deleteSection}
            </MenuItem>
            <MenuItem
              disabled={sectionCount.current === 1}
              style={{ fontSize: 12 }}
              onClick={() => {
                setAnchorEl(null);
                setOpenedAlert(true);
                setDeleteOption('section & questions');
              }}
            >
              {lang.form_builder.delSectionsQuestions}
            </MenuItem>
          </Menu>

          {openedAlert && (
            <ConfirmActionDialog
              isOpen={openedAlert}
              onClose={() => setOpenedAlert(false)}
              warningTitle={lang.form_builder.areYouSure}
              warningMessage={
                deleteOption === 'section'
                  ? lang.form_builder.sectionAlertOne
                  : lang.form_builder.sectionAlertTwo
              }
              onConfirmAction={deleteHandler}
              confirmActionButtonText={lang.form_builder.yesDelete}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
});

export { SectionComponent };
